import * as i0 from "@angular/core";
export class InfiniteScrollModule {
}
InfiniteScrollModule.ɵfac = function InfiniteScrollModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || InfiniteScrollModule)(); };
InfiniteScrollModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: InfiniteScrollModule });
InfiniteScrollModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({});
